import TagManager from "react-gtm-module";

function GoogleTagManagerHelper() {
  const tagManagerArgs = {
    gtmId: "GTM-5T6NVTQW",
  };

  TagManager.initialize(tagManagerArgs);
}

export { GoogleTagManagerHelper };
